<template>
  <div>
    <el-row>
      <el-col>
        <div justify="center">
          <!-- <el-alert
            class="center"
            v-if="this.currentCompany === 'MTR' || this.currentCompany === 'TB'"
            title="Esta tabla muestra el ultimo registro creado por el proceso de corte y reconexion"
            type="info"
            effect="dark"
            show-icon
            :closable="false"
          ></el-alert> -->
          <!-- <el-alert
            v-else
            title="No se muestran registros de corte y reconexion para esta compañia; solo para Magytrack"
            type="info"
            effect="dark"
            show-icon
            :closable="false"
          ></el-alert> -->
        </div>
      </el-col>
    </el-row>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="Reporte GPS" name="first">Reporte GPS</el-tab-pane>
      <el-tab-pane label="Reporte Terminales" name="second"
        >Reporte Terminales</el-tab-pane
      >
    </el-tabs>
    <!-- <el-button-group>
            <el-button type="primary" icon="el-icon-arrow-left">Reporte GPS</el-button>
            <el-button type="primary" @click="toggleHistoryJobs">Reporte Terminales<i class="el-icon-arrow-right el-icon-right"></i></el-button>
            <HistoryJobs v-if="showHistoryJobs" />
          </el-button-group>

           -->
    <rabbey-toolbox :filterables="true" @filter-search="handleSearch">
      <div class="mr-5">
        <el-select
          v-model="filterReason"
          placeholder="Filtra por la razon"
          size="mini"
          clearable
        >
          <el-option v-for="(v, index) in reasons2" :key="index" :value="v"
            >{{ v }}
          </el-option>
        </el-select>
      </div>
      <div class="mr-5">
        <el-select
          v-model="filterContractCondition"
          placeholder="Filtra por Condicion de Contrato"
          size="mini"
          clearable
        >
          <el-option
            v-for="(v, index) in ContractConditions"
            :key="index"
            :value="v"
            >{{ v }}
          </el-option>
        </el-select>
      </div>
    </rabbey-toolbox>
    <div
      v-show="
        this.currentCompany === 'MTR' ||
        this.currentCompany === 'TB' ||
        this.currentCompany === 'VF'
      "
    >
      <el-row type="flex" justify="space-around" :gutter="10">
        <el-col v-for="(value, key) in countReasons" :key="key">
          <CardStat
            :title="key"
            :val="value"
            icon="mdi mdi-checkbox-multiple-blank-outline"
          />
        </el-col>
      </el-row>

      <rabbey-table3
        :data="renderItems"
        :columns="columns"
        :loading="loading"
        :actions="actions"
        @rtable-push-action="handleCommand"
      />
      <customer-detail ref="details" />
      <NewFormRequest ref="NewFormRequest" :ResquestObject="uninstalResquest" />

      <CuttingUserModal
        :dialogVisible.sync="openCuttingUserModal"
        :clientName="actualRow.full_name"
        :Loading="loading"
        @ClosingDialog="OnCuttinGuserModalClose"
        @CuttingUser="OnCuttingUser"
      />
    </div>
  </div>
</template>

<script>
import reportUsersToCut from "@/columns/reportUsersToCut";
import CardStat from "@/components/CardStat";
import moment from "moment";
import NewFormRequest from "@/components/requests/NewRequestForm.vue";
import CuttingUserModal from "@/components/CutAndReconection/CuttingUserModal.vue";

export default {
  name: "ReportUsersToCut",
  components: {
    CardStat, //CustomerDetails,
    NewFormRequest,
    CuttingUserModal,
    "customer-detail": () =>
      import(
        /* webpackChunkName: "CustomerDetail" */ "@/components/customers/CustomerDetail.vue"
      )
  },
  created() {
    this.fetchData();
  },
  data() {
    //let self = this;
    return {
      showHistoryJobs: false,

      customercode: {},
      ContractStatus: "",
      clientData: {},
      loading: false,
      items: [],
      columns: reportUsersToCut(this),
      uninstalResquest: {
        DirectionId: 0,
        DepartmentId: 0,
        ResquestTypeId: 0
      },
      openCuttingUserModal: false,
      actualRow: {},
      // TODO: Esto se configura en la vista que consulta este reporte, quizas esto deba ser mejorado.
      reasons2: [
        "Codigo cliente invalido",
        "Cliente no existe",
        "Contrato cerrado",
        "Mas de una factura vencida"
      ],
      search: "",
      filterReason: "",
      ContractConditions: [
        "Abierto",
        "Cerrado",
        "Suspendido por Pago",
        "Cerrado por Clientes",
        "Cerrado por Legal"
      ],
      filterContractCondition: "",
      actions: [
        {
          command: "view-Client-Details",
          label: "Ver Detalle del Cliente",
          icon: "el-icon-view"
        },
        {
          command: "add-exception",
          label: "Agregar a exonerados de corte",
          icon: "el-e-plus",
          condition: () => this.IsInRole("CutterManager")
        },
        {
          command: "coordinate-uninstall",
          label: "Cordinar desinstalaciones de equipos",
          icon: "el-icon-phone-outline",
          condition: (row) => row.reason === "Contrato cerrado" // console.log("row: ", row)
        },
        {
          command: "reconnect-client",
          label: "Reconnectar cliente",
          icon: "el-icon-circle-check",
          condition: (row) => row.activated === false
        },
        {
          command: "cut-client",
          label: "Cortar cliente",
          icon: "el-icon-circle-close",
          condition: (row) => row.activated === true
        }
      ],
      openDrawer: false
    };
  },
  computed: {
    /**
     * Unique reasons
     * @returns {*[]}
     */
    reasons() {
      const items = this.items.map((m) => m.reason);
      const seen = {};
      const out = [];
      const len = items.length;
      let j = 0;
      for (let i = 0; i < len; i++) {
        const item = items[i];
        if (seen[item] !== 1) {
          seen[item] = 1;
          out[j++] = item;
        }
      }
      return out;
    },
    /**
     * Reason count
     * @returns {{}}
     */
    countReasons() {
      let out = {};
      const reasons = this.reasons2;
      for (let i = 0; i < reasons.length; i++) {
        const reason = reasons[i];
        out[reason] = this.items.filter((f) => f.reason === reason).length;
      }
      return out;
    },
    renderItems() {
      const search = this.search;
      const filterReason = this.filterReason;
      const filterContractCondition = this.filterContractCondition;
      let items = this.items;
      if (items == undefined || items == null || !items || items.length <= 0) {
        return [];
      }

      this.toggleLoading();
      const keys = Object.keys(this.items[0]);

      if (filterReason.length > 0) {
        items = items.filter((f) =>
          f.reason.toLowerCase().includes(filterReason.toLowerCase())
        );
      }
      //console.log("items: ",items)
      if (filterContractCondition.length > 0) {
        items = items.filter((f) =>
          f.contractCondition !== null
            ? f.contractCondition
                .toLowerCase()
                .includes(filterContractCondition.toLowerCase())
            : f.contractCondition !== null
        );
      }

      if (search.length > 0) {
        items = items.filter((data) => {
          for (let i = 0; i < keys.length; i++) {
            let value = data[keys[i]];
            const valueType = typeof value;
            if (["number", "boolean"].includes(valueType)) {
              value = value.toString();
            }
            if (value && value.toLowerCase().includes(search.toLowerCase())) {
              return data;
            }
          }
        });
      }
      this.toggleLoading();
      return items;
    }
  },
  methods: {
    handleClick(tab) {
      if (tab.label == "Reporte Terminales") {
        // console.log("esto aqui")
        this.toggleReport();
      }
    },
    toggleReport() {
      this.$router.push({ name: "record-cut-and-reconnection-ncf" });
    },
    toggleLoading() {
      this.loading = !this.loading;
    },
    async fetchData() {
      this.loading = true;
      await this.$http
        .get("/api/navixy/reportUsersToCut")
        .then((response) => {
          // console.log("reportUsersToCut fetchData response: ",response)
          response.data.forEach((cuttedUsers) => {
            cuttedUsers.daysInactive =
              moment(new Date())
                .diff(cuttedUsers.update_date, "days")
                .toString() + " dias";
          });
          this.items = response.data;
          //console.log("CyR response: ",this.items)
        })
        .catch((error) => console.error(error))
        .finally(() => (this.loading = false));
    },
    handleSearch(search) {
      this.search = search;
    },
    // metodoboton(){
    //   console.log("Estoy en el boton que quieres");
    // },
    handleCommand(action) {
      switch (action.command) {
        case "view-Client-Details": {
          //console.log("view-Client-Details action: ",action)
          this.$http
            .get(`/api/customers/${action.row.post_region}`)
            .then((resp) => {
              this.$refs.details.show(resp.data);
              this.$refs.details.drawer = true;
            })
            .catch((error) => {
              this.$message.error("Error al consultar los clientes");
              console.error(error);
              this.contractNo = 0;
            });

          this.clientData = action.row;
          break;
        }
        case "add-exception": {
          this.loading = true;
          this.$http
            .post(
              "/api/ReconnectionAndExceptions/CreateReconnectionAndExceptions",
              {
                clientCode: action.row.post_region,
                companyCode: this.currentCompany,
                rnc: "",
                ClientName: action.row.first_name
              }
            )
            .then((res) => {
              if (res.data) {
                this.$message.success("Cliente agregado!");
                // Elimina lo de la lista
                const index = this.items.findIndex(
                  (f) => f.navixy_id === action.row.navixy_id
                );
                if (index !== -1) {
                  this.items.splice(index, 1);
                }
              } else {
                this.$message.error("El cliente no fue agregado!");
              }

              this.loading = false;
            })
            .catch((err) => {
              console.error(err);
              this.loading = false;
            });
          break;
        }
        case "coordinate-uninstall": {
          this.uninstalResquest.DirectionId = 41;
          this.uninstalResquest.DepartmentId = 47;
          this.uninstalResquest.ResquestTypeId = 279;

          this.$refs.NewFormRequest.drawer = true;
          break;
        }
        case "reconnect-client": {
          this.$confirm(
            `¿Estas seguro que deseas reconectar el cliente ${action.row.full_name}?` +
              " Esta acción procederá a reactivar el cliente en Navixy" +
              " y reabrir su contrato.",
            `Confirmar reconexión del cliente`,
            {
              confirmButtonText: "Si",
              cancelButtonText: "No",
              type: "warning"
            }
          )
            .then(async () => {
              this.ContractStatus = 0;
              await this.UpdateNavixyUser(action.row);
            })
            .catch(() => {
              this.$message.info("Accion cancelada");
            });
          this.$message.success("Cliente reconectado!");
          break;
        }
        case "cut-client": {
          this.$confirm(
            `¿Estas seguro que deseas cortar el cliente ${action.row.full_name}?` +
              " Esta acción procederá a inactivar el cliente en Navixy" +
              " y cambiar el estatus de su contrato al seleccionado.",
            `Confirmar corte del cliente`,
            {
              confirmButtonText: "Si",
              cancelButtonText: "No",
              type: "warning"
            }
          )
            .then(async () => {
              this.actualRow = action.row;
              this.openCuttingUserModal = true;
            })
            .catch(() => {
              this.$message.info("Accion cancelada");
            });
          break;
        }
        default:
          break;
      }
    },

    /// Funcion para activar o desactivar el usuario en navixy, prontamenta tambien abrira o cerrara el contrato relacionado.
    async UpdateNavixyUser(row) {
      this.loading = true;
      await this.$http
        .put("/api/navixy/UpdateNavixyUserAndContract", {
          userId: row.id,
          activated: !row.activated,
          contractStatus: this.ContractStatus
        })
        .then(async () => {
          if (!row.activated) {
            this.$message.success("Cliente reconectado!");
          } else if (row.activated) {
            this.$message.success("Cliente cortado!");
          }
          this.openCuttingUserModal = false;
          await this.fetchData();
        })
        .catch((err) => {
          console.error(err);
          this.$message.error("Error al actualizar el cliente!");
        })
        .finally(() => (this.loading = false));
    },

    OnCuttinGuserModalClose(val) {
      this.openCuttingUserModal = val;
      // this.fetchData();
    },
    async OnCuttingUser(val) {
      this.ContractStatus = val;
      await this.UpdateNavixyUser(this.actualRow);
    }
  }
};
</script>

<style scoped>
.center {
  content: center;
}
</style>
